import { createSelector } from 'reselect';
export const getAiAssistantRoot = state => {
  return state.resources.aiAssistant;
};
export const getActionsGenerationResponse = createSelector(getAiAssistantRoot, root => {
  return root.generationResponse.actions;
});
export const getEnrollmentGenerationResponse = createSelector(getAiAssistantRoot, root => {
  return root.generationResponse.enrollment;
});
export const getActionsPrompt = createSelector(getAiAssistantRoot, root => {
  return root.actionsPrompt;
});